import {Outlet} from 'react-router-dom';
import {Layout as AppLayout} from 'src/layouts/app';
import HomePage from 'src/pages';
import Error401Page from 'src/pages/401';
import Error404Page from 'src/pages/404';
import Error500Page from 'src/pages/500';
import {authRoutes} from './auth';
import {CallCenterRoutes as callCenterRoutes} from "./call-center";
import {SupervisorRoutes as supervisorRoutes} from "./supervisor";
import {OssSupervisorRoutes as ossSupervisorRoutes} from "./oss-supervisor";
import {MonitorRoutes as monitorRoutes} from "./monitor";
import {ReportRoutes as reportRoutes} from "./report";
import {AdministratorRoutes as administratorRoutes} from "./administrator";
import {CRMRoute as CRMRoute} from "./crm";
export const routes = [
    {
        element: (
            <AppLayout>
                <Outlet/>
            </AppLayout>
        ),
        children: [
            {
                index: true,
                element: <HomePage/>
            },
        ]
    },

    ...authRoutes,
    ...callCenterRoutes,
    ...CRMRoute,
    ...monitorRoutes,
    ...supervisorRoutes,
    ...ossSupervisorRoutes,
    ...reportRoutes,
    ...administratorRoutes,


    {
        path: '401',
        element: <Error401Page/>
    },
    {
        path: '404',
        element: <Error404Page/>
    },
    {
        path: '500',
        element: <Error500Page/>
    },
    {
        path: '*',
        element: <Error404Page/>
    }
];
